module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Light.cf4449c1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/RobotoCondensed-Light.ttf
// module id = 709
// module chunks = 4